<template lang="pug"> 

div(class="container-fluid" style="padding-top:20px;")
    div(v-if="modulos") 
        ul(class="nav nav-tabs" id="myTab" role="tablist")
            li(class="nav-item" v-if="modulos" v-for="item of modulos")
                a( v-bind:class="[{active : item.activo},'nav-link']" href="#" @click="reset(item.NameReport)"   ) 
                    h4 {{item.NameReport}}  
        div(v-if="modulos" v-for="item of modulos")
            div(v-if="item.activo==true").table-responsive
                iframe(width="933" height="700" :src="item.UrlReport" frameborder="0" allowFullScreen="true")
            
</template>
<script>  
import Vue from 'vue'
import apiWeb from "../../api/apiSLC.js"
export default {
  
  data(){
      return{
             modulos :[]
      }
  },
  created(){
      var paramEnvio={IdUser: Vue.prototype.$info.idUser}
      apiWeb.post("ReportUrl/ReportUrl_ViewActive/",paramEnvio).then(val=> this.modulos=JSON.parse(val.value));
  },
  methods: {
        reset(titulo){
            this.modulos.forEach(element => {
                if(titulo==element.NameReport)
                    {element.activo=true }
                else
                    {element.activo=false}
            });
          
        }
    }
}
</script>
